import {CheckIcon, KebabHorizontalIcon, PencilIcon, TrashIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

import styles from './ShortcutOptionsButton.module.css'

interface ShortcutOptionsButtonProps {
  onEditView: () => void
  onDeleteView: () => void
  onUpdateQueryView: () => void
  isQueryModified?: boolean
}

export function ShortcutOptionsButton({
  onEditView,
  onDeleteView,
  onUpdateQueryView,
  isQueryModified = false,
}: ShortcutOptionsButtonProps) {
  const ariaLabel = isQueryModified ? 'Saved view menu (update available)' : 'Saved view menu'

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton
          icon={KebabHorizontalIcon}
          aria-label={ariaLabel}
          variant="invisible"
          className={isQueryModified ? styles.notificationIndicator : undefined}
        />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay width="small">
        <ActionList>
          {isQueryModified && (
            <ActionList.Item onSelect={onUpdateQueryView}>
              <ActionList.LeadingVisual>
                <CheckIcon />
              </ActionList.LeadingVisual>
              Update view with current query
            </ActionList.Item>
          )}
          <ActionList.Item onSelect={onEditView}>
            <ActionList.LeadingVisual>
              <PencilIcon />
            </ActionList.LeadingVisual>
            Edit view
          </ActionList.Item>

          <ActionList.Divider />

          <ActionList.Item variant="danger" onSelect={onDeleteView}>
            <ActionList.LeadingVisual>
              <TrashIcon />
            </ActionList.LeadingVisual>
            Delete
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}

try{ ShortcutOptionsButton.displayName ||= 'ShortcutOptionsButton' } catch {}